
export class CommonConstants {

  public static readonly mobileWidthThreshold = 585;
  public static readonly dashboardMobileWidthThreshold = 1100;
  public static readonly pinnedNavigationThreshold = 1350;

  public static readonly modalBreakpoints = {
    "1200px": "60vw",
    "950px": "85vw",
    "700px": '100vw',
  };

  public static readonly numberOfLineBarProperties = 5;
  public static readonly idealRunRateMaxValue = 1e9;
  public static readonly channelMaxValue = 99;
  public static readonly maxPlatenCount = 14;
  public static readonly maxChamberCount = 8;

  public static dataPointThreshold = 30000;
}
